import { configureClient, login, logout } from './authn'
import { FEATURES, STATUS_MESSAGES } from './constants'
import {
  applyTheme,
  checkDarkMode,
  displayApps,
  displayStatusMessage,
  setDarkMode,
  setFavicon,
} from './utilities'



window.onload = async () => {
  const logoutButton = document.querySelectorAll('.logout-button')
  setFavicon()
  try {
    if (FEATURES.showOnlyEnabledApps) {
      await configureClient()
      login()
    } else {
      displayApps()
    }
  } catch (e) {
    displayStatusMessage(STATUS_MESSAGES.serverError.message)
  }

  if (logoutButton) {
    logoutButton.forEach((instance) => {
      instance.addEventListener('click', () => {
        logout()
      })
    })
  }

  //Dark mode behaviour
  let isDarkmode = checkDarkMode()

  applyTheme(isDarkmode)

  document
    .getElementById('darkModeToggle')
    .addEventListener('click', function() {
      isDarkmode = !isDarkmode
      applyTheme(isDarkmode)
      setDarkMode(isDarkmode)
    })
}
